import actions from './actions'

const initialState = {
  moderationActivityList: [],
  moderationActivityListPagination: {},
  moderationActivityListTotal: 0,
  moderationFlaggedMessagesList: [],
  moderationFlaggedMessagesListPagination: {},
  moderationFlaggedMessagesListTotal: 0,
  moderationReviewedMessagesList: [],
  moderationReviewedMessagesListPagination: {},
  moderationReviewedMessagesListTotal: 0,
  moderationRulesList: [],
  moderationRulesListPagination: {},
  moderationRulesListTotal: 0,
  moderationRulesNonDefaultListTotal: 0,
  moderationRuleActive: [],
  moderationKeywordsList: [],
  moderationKeywordListTotal: 0,
  moderationKeywordNonDefaultListTotal: 0,
  moderationKeywordListPagination: {},
  areModerationSectionsLoading: false,
  isModerationActivityLoading: false,
  isModerationFlaggedMessagesLoading: false,
  isModerationReviewedMessagesLoading: false,
  moderationRuleRevisionsList: [],
  moderationRuleRevisionsListPagination: {},
  moderationRuleRevisionsListTotal: 0,
  moderationKeywordActive: [],
  moderationConfigurationList: [],
  moderationActivityListPaginationCurentParams: {},
  moderationFlaggedMessagesListPaginationCurrentParams: {},
  moderationReviewedMessagesListPaginationCurrentParams: {},
  moderationLocallyReviewedFlagIds: [],
  moderationOpenAICustomAPISettings: {},
  showAddCustomCategories: false,
  showEditCustomCategories: false,
  customCategoriesList: [],
  isCustomCategoriesLoading: false,
  flaggedByUsers: [],
  flaggedByUsersTotal: 0,
  flaggedByUsersPagination: {},
}

export default function moderationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
